/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseBlogGridFragment, BlogGridFragment, FullBlogGridFragment} from '@amblique/contentful/app/contentful/fragments/blog-grid';

/**
 * Get a single BlogGrid by ID (base - scalars only)
 */
export const getBaseBlogGridById = gql`
  ${BaseBlogGridFragment}

  query GetBaseBlogGridById($id: String!, $locale: String!, $preview: Boolean) {
    blogGrid(id: $id, locale: $locale, preview: $preview) {
      ...BaseBlogGridFragment
    }
  }
`;

/**
 * Get a single BlogGrid by ID (standard - 1 level deep)
 */
export const getBlogGridById = gql`
  ${BlogGridFragment}

  query GetBlogGridById($id: String!, $locale: String!, $preview: Boolean) {
    blogGrid(id: $id, locale: $locale, preview: $preview) {
      ...BlogGridFragment
    }
  }
`;

/**
 * Get a single BlogGrid by ID (full - 2 levels deep)
 */
export const getFullBlogGridById = gql`
  ${FullBlogGridFragment}

  query GetFullBlogGridById($id: String!, $locale: String!, $preview: Boolean) {
    blogGrid(id: $id, locale: $locale, preview: $preview) {
      ...FullBlogGridFragment
    }
  }
`;

/**
 * Get all BlogGrid entries with pagination (base - scalars only)
 */
export const getBaseBlogGrids = gql`
  ${BaseBlogGridFragment}

  query GetBaseBlogGrids(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [BlogGridOrder]
    $where: BlogGridFilter
    $preview: Boolean
  ) {
    blogGridCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseBlogGridFragment
      }
    }
  }
`;

/**
 * Get all BlogGrid entries with pagination (standard - 1 level deep)
 */
export const getBlogGrids = gql`
  ${BlogGridFragment}

  query GetBlogGrids(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [BlogGridOrder]
    $where: BlogGridFilter
    $preview: Boolean
  ) {
    blogGridCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BlogGridFragment
      }
    }
  }
`;

/**
 * Get all BlogGrid entries with pagination (full - 2 levels deep)
 */
export const getFullBlogGrids = gql`
  ${FullBlogGridFragment}

  query GetFullBlogGrids(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [BlogGridOrder]
    $where: BlogGridFilter
    $preview: Boolean
  ) {
    blogGridCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullBlogGridFragment
      }
    }
  }
`;
